<template>
<button
  v-if="$can('events.link.stock')"
  :disabled="loading"
  @click="handleAssociateStock()"
  class="btn btn-fill btn-wd btn-warning btn-block btn-router"
>
  Associar Estoque
</button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import swal from 'sweetalert2'

export default {
  name: 'BtnAssociateStock',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('stocks', {
      stocks: 'stocks'
    }),

    ...mapGetters('tickets', {
      ticketsWinners: 'winners'
    }),

    ...mapGetters('events', ['event']),

    countAvailableRefrigeratorsOnStock () {
      return this.availableStocks.reduce(
        (sum, stock) => sum + stock.left, 0
      )
    },

    countRefrigeratorsOnStock () {
      return this.availableStocks.reduce(
        (sum, stock) => sum + stock.total, 0
      )
    },

    usedStocks () {
      return this.ticketsWinners.reduce(function (allTickets, ticket) {
        if (ticket.stockId !== null) {
          if (ticket.stockId in allTickets) {
            allTickets[ticket.stockId]++
          } else {
            allTickets[ticket.stockId] = 1
          }
        }
        return allTickets
      }, {})
    },

    availableStocks () {
      return this.stocks.map(item => {
        let used = item._id in this.usedStocks ? this.usedStocks[item._id] : 0
        return {
          _id: item._id,
          left: parseInt(item.numberOfRefigerators) - used,
          total: parseInt(item.numberOfRefigerators)
        }
      })
    },

    ticketsWinnersWithoutStock () {
      return this.ticketsWinners.filter(item => !item.stockId)
    },

    countTicketsWinnersWithoutStock () {
      return this.ticketsWinnersWithoutStock.length
    }
  },

  methods: {
    ...mapActions(['changeExecution']),
    ...mapActions('tickets', ['associateStock']),
    ...mapActions('stocks', { fetchStocks: 'fetchAll' }),

    handleAssociateStock () {
      console.log('1')
      let swalOptions = {
        title: `${this.countTicketsWinnersWithoutStock} ticket(s)</b> sem estoque`,
        html: `Há ${this.stocks.length} nota(s) fiscai(s) cadastrada(s) com <b class="text-success">${this.countAvailableRefrigeratorsOnStock} refrigeradores</b> disponíveis de um total de <b class="text-warning">${this.countRefrigeratorsOnStock} em estoque</b>.`
      }

      if (this.countTicketsWinnersWithoutStock === 0) {
        return swal({
          title: swalOptions.title,
          text: `Todos os tickets ganhadores já estão associados com estoque.`,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }

      if (this.countAvailableRefrigeratorsOnStock === 0) {
        return swal({
          title: swalOptions.title,
          html: `Não há estoque disponível.<br /><br />` + swalOptions.html,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      }

      return swal({
        title: swalOptions.title,
        html: swalOptions.html + `<br /><br /> Você deseja associar o estoque disponível?`,
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Sim, desejo associar!',
        cancelButtonText: 'Não',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      })
        .then((result) => {
          if (result) {
            this.execAssociateStock()
          }
        })
    },

    execAssociateStock () {
      this.loading = true
      this.changeExecution(true)
      let index = 0
      let tickets = _.cloneDeep(this.ticketsWinnersWithoutStock)
      let stockLeft = []
      for (let stock of this.availableStocks) {
        if (stock.left <= 0) {
          continue
        }

        stockLeft.push(stock.left)

        for (let i = 0; i < stock.left; i++) {
          if (!tickets[index]) {
            break
          }
          tickets[index].stockId = stock._id
          _.unset(tickets[index], 'customer')
          _.unset(tickets[index], 'stock')
          ++index
        }
      }

      let totalStockLeft = _.sum(stockLeft)
      tickets = _.slice(tickets, 0, totalStockLeft)
      console.log(tickets)
      this.associateStock({ tickets }).then(() => {
        swal('Sucessso', 'Estoque associado com sucesso.', 'success')
        this.$emit('fetchTickets')
      }).catch(err => {
        swal({
          width: 1000,
          title: 'Ocorreu um erro ao associar estoque.',
          text: JSON.stringify(err),
          type: 'error',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      }).finally(() => {
        this.loading = false
        this.changeExecution(false)
      })
    }
  },

  mounted () {
    this.fetchStocks({ where: { eventId: this.event._id }, limit: 99 })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnAssociateStock.vue